import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Дефолтные метатеги для всего приложения
 * Могут быть переопределены на конкретных страницах
 */
export const AppMeta: React.FC = () => {
    return (
        <Helmet>
            <title>Промптхаб — место обмена промптами для Алисы AI и других нейросетей</title>
            <meta
                name="description"
                content="База работающих промптов, курсы и челленджи для нейросетей. Учитесь на кейсах экспертов, делитесь своими решениями и применяйте всё сразу в Алисе AI бесплатно."
            />
            <meta property="og:image" content="https://yastatic.net/s3/distribution/prompthub/og-image.png" />
        </Helmet>
    );
};
